import React, { useEffect, useState } from "react";
import "./ModalBannerStyles.scss";
import { Link } from "react-router-dom";

export default function ModalBanner({
    setIsOpen,
    imageMobile,
    imageDesktop,
    dateExpired,
}: {
    setIsOpen: (e: boolean) => void;
    imageMobile: string;
    imageDesktop: string;
    dateExpired?: string;
}) {
    const [isExpired, setIsExpired] = useState(false);
    const [isShowed, setIsShowed] = React.useState(false);
    const [timeLeft, setTimeLeft] = useState({
        days: "0",
        hours: "0",
        minutes: "0",
        seconds: "0",
    });

    useEffect(() => {
        if (dateExpired) {
            const interval = setInterval(() => {
                const now = new Date();
                const target = new Date(dateExpired);
                const difference = target.getTime() - now.getTime();

                if (difference <= 0) {
                    clearInterval(interval);
                    setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
                    setIsExpired(true); // Oculta la sección cuando el tiempo expira
                    return;
                }

                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / (1000 * 60)) % 60);
                const seconds = Math.floor((difference / 1000) % 60);

                setTimeLeft({
                    days: String(days).padStart(2, "0") + ":",
                    hours: String(hours).padStart(2, "0") + ":",
                    minutes: String(minutes).padStart(2, "0") + ":",
                    seconds: String(seconds).padStart(2, "0"),
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, []);

    return (
        <>
            {isExpired ? (
                <></>
            ) : (
                <div
                    className="success_modal_container"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(false);
                    }}
                >
                    <div
                        className="container-image"
                        style={{
                            position: "relative",
                        }}
                    >
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsOpen(false);
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            <img src={imageDesktop} className="banner-desktop" />
                            <img src={imageMobile} className="banner-desktop banner-mobile " />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
